<h1 mat-dialog-title>
  {{title}}
</h1>

<div mat-dialog-content>
  <p>{{message}}</p>
</div>

<mat-dialog-actions align="end">
  <button mat-raised-button (click)="tryAnotherExample()">Show me around</button>
  <button mat-raised-button color="primary" (click)="backToHome()">Explore on my own</button>
</mat-dialog-actions>
